export default function Spacer({ size, double, half, horizontal = false }) {
  size = double ? 8 * 3 : half ? 8 / 2 : size || 10
  return horizontal ? (
    <div style={{ width: size }} />
  ) : (
    <div style={{ height: size }} />
  )
}
